import axios from "axios";
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Modal,
  Table,
} from "react-bootstrap";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../../components/Common/Spinner";
import {
  MdDeleteForever,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdOutlineDeleteSweep,
  MdPersonOff,
} from "react-icons/md";
import Plans from "./Plans";
import Topup from "./Topup";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropImage";
import "./user-account-setting.css";
import Header from "../../../components/partials/dashboard/HeaderStyle/header";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getToken } from "../../../utils/auth";
import * as moment from "moment";
import validateEmail from "../../../utils/validateEmail";
import validatePhoneNumber from "../../../utils/validatePhoneNumber";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const UserAccountSetting = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    image: "",
  });
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeDevices, setActiveDevices] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [action, setAction] = useState("");
  const [recovery, setrecovery] = useState("");

  const [email, setEmail] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [error, setError] = useState("");
  const [phone, setPhone] = useState("");
  const [businessName, setBusinessName] = useState("Business Name");
  const [phoneOtp, setPhoneOtp] = useState("");
  const [verified, setVerified] = useState({ phone: false });
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);
  const [invitationEmail, setInvitationEmail] = useState("");
  const { userData, updateUserProfile, fetchUserData } = useUser();
  const [isPrivate, setIsPrivate] = useState(false);
  const isMounted = useRef(false);

  // useEffect(() => {
  //   if (!isMounted.current) {
  //     isMounted.current = true;
  //     return;
  //   }

  //   const updatePrivacySetting = async () => {
  //     const apiUrl = `${process.env.REACT_APP_URL}/api/user/social-profile`;
  //     const privacyData = {
  //       privacySettings: {
  //         showContactDetail: !isPrivate,
  //         isPublic: !isPrivate,
  //       },
  //     };

  //     try {
  //       const token = getToken();
  //       const response = await axios.put(apiUrl, privacyData, {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json',
  //         },
  //       });
  //         toast.success('Privacy settings updated successfully');
  //     } catch (error) {
  //       toast.error('Error occurred while updating privacy settings');
  //     }
  //   };
  //   updatePrivacySetting();
  // }, [isPrivate]);

  const updatePrivacySetting = async (isPrivateValue, showToast = true) => {
    const apiUrl = `${process.env.REACT_APP_URL}/api/user/social-profile`;
    const privacyData = {
      privacySettings: {
        showContactDetail: !isPrivateValue,
        isPublic: !isPrivateValue,
      },
    };
  
    try {
      const token = getToken();
      const response = await axios.put(apiUrl, privacyData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (showToast) {
        toast.success("Privacy settings updated successfully");
      }
    } catch (error) {
      if (showToast) {
        toast.error("Error occurred while updating privacy settings");
      }
    }
  };
  

  // useEffect(() => {
  //   if (!isMounted.current) {
  //     isMounted.current = true;
  //     return;
  //   }

  // }, [isPrivate]);

  const handlePrivacyChange = (e) => {
    const newValue = e.target.value === "Private";
    setIsPrivate(newValue);
    updatePrivacySetting(newValue);
  };
  
  const sendInvitation = async () => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/user/invite`,
        {
          emailIds: [invitationEmail],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setInvitationEmail("");
      toast.success(response?.data?.message || "Invitation sent successfully!");
    } catch (error) {
      console.error("Error sending invitation:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to send invitation. Please try again."
      );
    }
  };

  const handleGenerateOTPMobile = async (e) => {
    e.preventDefault();
    if (!phone) {
      toast.error("Please Enter Mobile Number");
      return;
    }
    try {
      setLoading(true);
      if (recovery?.recoveryMobile?.mobile === phone) {
        setPhone("");
        return toast.error(
          "This mobile number is already registered as recovery mobile."
        );
      } else if (user?.mobile === phone) {
        setPhone("");
        return toast.error(
          "This mobile number is already registered as primary mobile."
        );
      }
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/mobile-generateOTP`,
        {
          mobile: phone,
          verificationFor: "recovery-mobile",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setPhoneOtpSent(true);
      toast.success(response.data.message);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while generating OTP.");
      }

      console.log("Error in Generating OTP", error);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTPMobile = async (e) => {
    e.preventDefault();
    if (!phoneOtp) {
      toast.error("Please Enter OTP");
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/mobile-verifyOTP`,
        {
          mobile: phone,
          mobileOTP: phoneOtp,
          verificationFor: "recovery-mobile",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Otp verified successfully");
      updateSecuritySettingsMobile();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while verifying OTP.");
      }

      console.log("Error in verifying OTP", error);
    } finally {
      setLoading(false);
    }
  };

  const updateSecuritySettingsMobile = async () => {
    try {
      const token = getToken();
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/security-settings`,
        {
          recoveryMobile: {
            mobileCode: "00",
            mobile: phone,
            isRecoveryMobileVerified: true,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setPhone("");
      setPhoneOtp("");
      setPhoneOtpSent(false);
      handleRecoveryData();
      toast.success(
        response?.data?.message || "Recovery mobile verified successfully!"
      );
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          "Failed to update security settings. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp1 = (type) => {
    if (type === "email" && email) {
      setEmailOtpSent(true);
    } else if (type === "phone" && phone) {
      setPhoneOtpSent(true);
    }
  };

  const handleVerifyOtp1 = (type) => {
    if (type === "email" && emailOtp) {
      setVerified((prev) => ({ ...prev, email: true }));
    } else if (type === "phone" && phoneOtp) {
      setVerified((prev) => ({ ...prev, phone: true }));
    }
  };

  // Function to handle OTP generation
  const handleSendOtp = async () => {
    if (!validateEmailCheck(email)) {
      setError("Please enter a valid email.");
      return;
    }

    try {
      setError("");
      if (recovery?.recoveryEmail?.email === email) {
        setEmail("");
        return toast.error(
          "This Email is already registered as recovery Email."
        );
      } else if (user?.email === email) {
        setEmail("");
        return toast.error(
          "This Email is already registered as primary Email."
        );
      }
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/generateOTP`,
        {
          email,
          verificationFor: "recovery-email",
        }
      );

      setEmailOtpSent(true);
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          "Failed to send OTP. Please try again."
      );
    }
  };

  // Function to handle OTP verification
  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/verifyOTP`,
        {
          email,
          emailOTP: emailOtp,
        }
      );

      setVerifiedEmail(true);
      setError("");
      await updateSecuritySettings();
    } catch (error) {
      setError(
        error?.response?.data?.message || "Invalid OTP. Please try again."
      );
    }
  };

  const updateSecuritySettings = async () => {
    try {
      const token = getToken();
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/security-settings`,
        {
          recoveryEmail: {
            email,
            isRecoveryEmailVerified: true,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setEmail("");
      setEmailOtp("");
      setEmailOtpSent(false);
      setVerifiedEmail(false);
      handleRecoveryData();
      toast.success(
        response?.data?.message || "Recovery email verified successfully!"
      );
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          "Failed to update security settings. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Validate email format
  const validateEmailCheck = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleShowPopup = (selectedAction) => {
    setAction(selectedAction);
    setShowPopup(true);
  };

  const handleApiRequest = async () => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/account-action`,
        { action },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            // "accept": "*/*"
          },
        }
      );
      toast.success(
        response?.data?.messsage || "Request submitted successfully!"
      );
    } catch (error) {
      toast.error(
        error?.response?.data?.messsage ||
          "There was an error submitting your request"
      );
    } finally {
      setShowPopup(false);
    }
  };
  const handleActiveDevices = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/auth/active-sessions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setActiveDevices(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Active Devices Details", error);
    }
  };

  const handleRecoveryData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/security-settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setrecovery(response?.data?.data.securitySettingsdata);
    } catch (error) {
      console.error("Failed Fetching Recovery Details", error);
    }
  };

  const handleDelete = async (id) => {
    if (!id) {
      toast.info("Please try later");
      return;
    }
    setLoading(true);
    const token = getToken();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/logout/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleActiveDevices();
      toast.success(response?.data?.messsage || "Logged out successfully");
    } catch (error) {
      console.log("Failed Deleting Condition", error);
      toast.error(
        error?.response?.data?.messsage || "Failed logging out device"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchUserData1 = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const twoFactorFlag =
        response?.data?.data?.enableTwoFactorAuthentication || false;
      setIs2FAEnabled(twoFactorFlag);
      const isPublic = response?.data?.data?.isPublic;
      setIsPrivate(!isPublic);
      setUser(response?.data?.data);
    } catch(error){
      console.error("Failed Fetching Details", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleRecoveryData();
    handleActiveDevices();
    fetchUserData1();
  }, []);

  const updateTwoFactor = async (status) => {
    try {
      const token = getToken();
      const payload = { enableTwoFactorAuthentication: status };

      await axios.put(
        `${process.env.REACT_APP_URL}/api/user/security-settings`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      fetchUserData1();
      fetchUserData();
      toast.success(
        `Two-Factor Authentication ${
          status ? "enabled" : "disabled"
        } successfully`
      );
    } catch (error) {
      console.error("Error updating 2FA status:", error);
      toast.error(
        error?.response?.data?.message || "Failed to update 2FA status"
      );
    }
  };

  const handleUserChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const updateUserData = async (e) => {
    setLoading(true);
    e.preventDefault();
      if (!(await validatePhoneNumber(user.mobile))) {
        toast.error("Invalid phone number.");
            setLoading(false)
        return;
      }
    const formData = new FormData();
    formData.append("firstName", user?.firstName);
    formData.append("email", user?.email);
    formData.append("lastName", user?.lastName);
    formData.append("mobile", user?.mobile);
    formData.append("profileImage", user.image);
    formData.append("mobileCode", "00");
    formData.append("nameOfBusiness", user.nameOfBusiness);

    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/edit-profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user update", response.data.data);
      updateUserProfile(response.data.data);
      toast.success("Profile Updated successfully!");
      fetchUserData1();
      fetchUserData();
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
      setRefresh(!refresh);
    }
  };

  // const handleProfilePictureChange = (event) => {
  //   const file = event.target.files[0];
  //   const reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //     setImageSrc(reader.result);
  //     setShowModal(true);
  //   });
  //   reader.readAsDataURL(file);
  // };

  const handleProfilePictureChange = (event) => {
  const file = event.target.files[0];

  if (!file) return;

  const maxSize = 1 * 1024 * 1024; // 1MB

  // 🚫 Block file if size exceeds 1MB
  if (file.size > maxSize) {
    toast.error("Image size must not exceed 1MB");
    event.target.value = ""; // clear selected file
    return;
  }

  // ✔ If file is valid, preview it
  const reader = new FileReader();
  reader.onload = () => {
    setImageSrc(reader.result);
    setShowModal(true);
  };
  reader.readAsDataURL(file);

  // Store file for upload
  setUser((prev) => ({ ...prev, image: file }));
};


  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      setUser({
        ...user,
        image: croppedImage,
      });
      setImageSrc(null);
      setShowModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [imageSrc, croppedAreaPixels, user]);

  const [isActiveAccount, setIsActiveAccount] = useState(false);
  const [isActiveRequest, setIsActiveRequest] = useState(false);
  const [isActivePassword, setIsActivePassword] = useState(false);
  const [isActivePlans, setIsActivePlans] = useState(false);
  const [isActiveErase, setIsActiveErase] = useState(false);
  const [isActiveRecovery, setIsActiveRecovery] = useState(false);
  const [isActiveInvitation, setIsActiveInvitation] = useState(false);
  const [isActiveTopup, setIsActiveTopup] = useState(false);
  const [isActiveStatus, setIsActiveStatus] = useState(false);
  const [isActiveTwoFA, setIsActiveTwoFA] = useState(false);

  const toggleSection = (section) => {
    setIsActiveAccount(section === "account");
    setIsActiveRequest(section === "qrrequest");
    setIsActivePassword(section === "password");
    setIsActivePlans(section === "plans");
    setIsActiveErase(section === "dataEraseRequest");
    setIsActiveRecovery(section === "recovery");
    setIsActiveInvitation(section === "invitation");
    setIsActiveTopup(section === "topup");
    setIsActiveStatus(section === "status");
    setIsActiveTwoFA(section === "twofa");
    setTimeout(() => {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
  };
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const handleToggle = () => {
    const newStatus = !is2FAEnabled;
    setIs2FAEnabled(newStatus);
    updateTwoFactor(newStatus);
  };
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
const [showOld, setShowOld] = useState(false);
const [showNew, setShowNew] = useState(false);
const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  };
  const updatePassword = async (e) => {
    e.preventDefault();
    const { oldPassword, newPassword, confirmNewPassword } = passwordData;

    // Basic validations
    if (!oldPassword) {
      toast.error("Current password is required");
      return;
    }

    if (!newPassword) {
      toast.error("New password is required");
      return;
    }

    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    // Advanced validations
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasLowerCase = /[a-z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);

    if (!hasUpperCase) {
      toast.error("Password must contain at least one uppercase letter");
      return;
    }

    if (!hasLowerCase) {
      toast.error("Password must contain at least one lowercase letter");
      return;
    }

    if (!hasNumber) {
      toast.error("Password must contain at least one number");
      return;
    }

    if (!hasSpecialChar) {
      toast.error("Password must contain at least one special character");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords don't match");
      return;
    }

    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/change-password`,
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Password changed successfully");
      setPasswordData({
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
    } catch (error) {
      console.error("Password change error:", error);
      toast.error(error.response?.data?.message || "Failed to change password");
    }
  };

  const [refresh, setRefresh] = useState(false);
  const [qrCodeRequest, setQrCodeRequest] = useState("");

  const handleQrCodeRequest = (e) => {
    setQrCodeRequest(e.target.value);
  };

  const submitQrCodeRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/identifier-reservation/request`,
        {
          identifier: qrCodeRequest,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("QR Code request sent successfully!");
      setQrCodeRequest("");
    } catch (error) {
      toast.error("Failed to send QR Code request.");
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneChange = (mobile, field) => {
    setUser({ ...user, [field]: mobile });
  };

  const handlePhoneChangeRecovery = (value) => {
    // const onlyNumbers = value.replace(/[^0-9]/g, '');  // Allow only digits
    setPhone(value);
  };
  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Container className="p-2" style={{ marginTop: "2%"}}>
          {/* //  <Row> */}
                    <Col lg="12">
 
          {/* Account */}
          <div
            id="account"
            className="accordion"
            style={{ marginBlock: "5px"}}
          >
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                onClick={() => {
                  toggleSection("account");
                  setIsActiveAccount(!isActiveAccount);
                }}
                // onClick={() => toggleSection('account')}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                  {t("account_setting")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveAccount ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveAccount && (
                <div className="accordion-content">
                  <Card>
                    <Card.Body>
                      <div className="acc-edit">
                        <Form onSubmit={updateUserData}>
                          <Form.Group className="form-group">
                            <Form.Label
                              htmlFor="lastName"
                              className="form-label"
                            >
                              {t("first_name_label")}:
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className="form-control"
                              id="firstName"
                              name="firstName"
                              defaultValue={user?.firstName}
                              value={user?.firstName}
                              onChange={handleUserChange}
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label
                              htmlFor="lastName"
                              className="form-label"
                            >
                              {t("last_name_label")}:
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className="form-control"
                              id="lastName"
                              name="lastName"
                              defaultValue={user?.lastName}
                              value={user?.lastName}
                              onChange={handleUserChange}
                            />
                          </Form.Group>
                          {user?.clientUseFor === "business" ? (
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="nameOfBusiness"
                                className="form-label"
                              >
                                {t("Business Name")}:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                className="form-control"
                                id="nameOfBusiness"
                                name="nameOfBusiness"
                                defaultValue={user?.nameOfBusiness}
                                value={user?.nameOfBusiness}
                                onChange={handleUserChange}
                              />
                            </Form.Group>
                          ) : (
                            ""
                          )}
                          <Form.Group className="form-group">
                            <Form.Label htmlFor="mobile" className="form-label">
                              {t("mobile_number")}:
                            </Form.Label>
                            <PhoneInput
                              country={(user?.country || "us").toLowerCase()}
                              value={user?.mobile}
                              onChange={(mobile) =>
                                handlePhoneChange(mobile, "mobile")
                              }
                              inputStyle={{ width: "100%" }}
                              required
                            />
                            {/* <Form.Control
                              type="text"
                              className="form-control"
                              id="mobile"
                              name="mobile"
                              defaultValue={user?.mobile}
                              value={user?.mobile}
                              onChange={handleUserChange}
                            /> */}
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label
                              htmlFor="profilePicture"
                              className="form-label"
                            >
                              {t("profile_picture")}:
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleProfilePictureChange}
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label htmlFor="email" className="form-label">
                              {t("email_id")}:
                            </Form.Label>
                            <Form.Control
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                              defaultValue={user.email}
                              value={user?.email}
                              disabled
                              onChange={handleUserChange}
                            />
                          </Form.Group>
                          {recovery?.recoveryEmail?.email && (
                            <Form.Group className="form-group">
                              <Form.Label
                                htmlFor="email"
                                className="form-label"
                              >
                                {t("recovery_email")}:
                              </Form.Label>
                              <Form.Control
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                defaultValue={recovery?.recoveryEmail?.email}
                                value={recovery?.recoveryEmail?.email}
                                disabled
                              />
                            </Form.Group>
                          )}
                          {recovery?.recoveryMobile?.mobile && (
                            <Form.Group className="form-group">
                              <Form.Label className="form-label">
                                {t("recovery_phone")}:
                              </Form.Label>
                              <Form.Control
                                // type="email"
                                className="form-control"
                                // id="email"
                                // name="email"
                                defaultValue={recovery?.recoveryMobile?.mobile}
                                value={recovery?.recoveryMobile?.mobile}
                                disabled
                              />
                            </Form.Group>
                          )}
                          <Button
                            type="submit"
                            className="btn btn-primary me-2"
                          >
                            {t("submit_button")}
                          </Button>
                          <Button type="reset" className="btn bg-soft-danger">
                            {t("cancel")}
                          </Button>
                        </Form>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </div>
          </div>
          {/* Status */}
          <div id="status" className="accordion" style={{ marginBlock: "5px" }}>
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                onClick={() => {
                  toggleSection("status");
                  setIsActiveStatus(!isActiveStatus);
                }}
                // onClick={() => toggleSection('account')}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                  {t("account_privacy")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveStatus ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveStatus && (
                <div className="accordion-content">
                  <Card>
                    <Card.Body>
                      <div className="acc-edit">
                        <Form>
                          {/* Account Privacy Section */}
                          <Form.Group
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                          >
                            <Form.Check
                              style={{
                                display: "flex",
                                width: "50%",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              type="radio"
                              id="privacyPublic"
                              label="Public"
                              name="accountPrivacy"
                              value="Public"
                              checked={!isPrivate}
                              onChange={handlePrivacyChange}
                            />
                            <Form.Check
                              style={{
                                display: "flex",
                                width: "50%",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              type="radio"
                              id="privacyPrivate"
                              label="Private"
                              name="accountPrivacy"
                              value="Private"
                              checked={isPrivate}
                              onChange={handlePrivacyChange}
                            />
                          </Form.Group>
                        </Form>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </div>
          </div>
          {/* 2FA */}
          <div id="twofa" className="accordion" style={{ marginBlock: "5px" }}>
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                onClick={() => {
                  toggleSection("twofa");
                  setIsActiveTwoFA(!isActiveTwoFA);
                }}
                // onClick={() => toggleSection('account')}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                 {t("twoFactorAuthentication")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveTwoFA ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveTwoFA && (
                <div className="accordion-content">
                  <Card>
                    <Card.Body>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <h5 style={{ margin: 0 }}>
                 {t("twoFactorAuthentication")}</h5>
                        <Form.Check
                          style={{ whiteSpace: "nowrap" }}
                          type="switch"
                          id="2fa-toggle"
                          label={is2FAEnabled ? "On" : "Off"}
                          checked={is2FAEnabled}
                          onChange={handleToggle}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </div>
          </div>
          {/* Change Password */}
          {user?.loggedInWithSocialLogin === false && (
            <div
              id="password"
              className="accordion"
              style={{ marginBlock: "5px" }}
            >
              <div
                className="accordion-item"
                style={{ borderBottom: "1px solid #a5a5a5" }}
              >
                <div
                  className="accordion-title"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingInline: "20px",
                  }}
                  onClick={() => {
                    toggleSection("password");
                    setIsActivePassword(!isActivePassword);
                  }}
                  // onClick={() => toggleSection('password')}
                >
                  <div
                    style={{
                      display: "flex",
                      fontSize: "20px",
                      paddingBlock: "5px",
                    }}
                  >
                    {t("change_password")}
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {isActivePassword ? (
                      <MdKeyboardArrowUp size={30} />
                    ) : (
                      <MdKeyboardArrowDown size={30} />
                    )}
                  </div>
                </div>
                {isActivePassword && (
                  <div
                    className="accordion-content"
                    //    style={{display:"flex", flexDirection:"row", width:"100%", justifyContent:"space-between", padding:"20px"}}
                  >
                    <Card>
                      <Card.Body>
                        <div className="acc-edit">
                         <Form onSubmit={updatePassword}>
  {/* Old Password */}
  <Form.Group className="form-group">
    <Form.Label className="form-label">
      {t("old_password")}:
    </Form.Label>

    <div style={{ position: "relative" }}>
      <Form.Control
        type={showOld ? "text" : "password"}
        name="oldPassword"
        value={passwordData.oldPassword}
        onChange={handleChange}
        className="form-control"
        placeholder={t("old_password_placeholder")}
        required
      />

      <span
        onClick={() => setShowOld(!showOld)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showOld ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
  </Form.Group>

  {/* New Password */}
  <Form.Group className="form-group">
    <Form.Label className="form-label">
      {t("new_password")}:
    </Form.Label>

    <div style={{ position: "relative" }}>
      <Form.Control
        type={showNew ? "text" : "password"}
        name="newPassword"
        value={passwordData.newPassword}
        onChange={handleChange}
        className="form-control"
        placeholder={t("new_password_placeholder")}
        required
      />

      <span
        onClick={() => setShowNew(!showNew)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showNew ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
  </Form.Group>

  {/* Confirm New Password */}
  <Form.Group className="form-group">
    <Form.Label className="form-label">
      {t("confirm_new_password")}:
    </Form.Label>

    <div style={{ position: "relative" }}>
      <Form.Control
        type={showConfirm ? "text" : "password"}
        name="confirmNewPassword"
        value={passwordData.confirmNewPassword}
        onChange={handleChange}
        className="form-control"
        placeholder={t("confirm_new_password_placeholder")}
        required
      />

      <span
        onClick={() => setShowConfirm(!showConfirm)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showConfirm ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
  </Form.Group>

  {/* Buttons + last changed */}
  <div className="d-flex justify-content-between">
    <div style={{display:"flex"}}>
      <Button type="submit" className="btn btn-primary me-2">
        {t("submit_button")}
      </Button>
      <Button type="reset" className="btn bg-soft-danger">
        {t("cancel")}
      </Button>
    </div>
  </div>
      {user?.passwordLastChangedAt && (
      <div style={{marginTop:"10px", justifyContent:"right", display:"flex"}}>
        {t("lastPasswordChanged")}:{" "}
        {moment(user.passwordLastChangedAt).format("MMMM D, YYYY h:mm A")}
      </div>
    )}
</Form>

                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* Recovery Email/Phone */}
          <div
            id="recovery"
            className="accordion"
            style={{ marginBlock: "5px" }}
          >
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                // onClick={() => toggleSection('recovery')}
                onClick={() => {
                  toggleSection("recovery");
                  setIsActiveRecovery(!isActiveRecovery);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                  {t("add_recovery_mobile_email")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveRecovery ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveRecovery && (
                <div className="accordion-content">
                  <Card>
                    <Card.Body>
                      <Form>
                        {/* Email Field with Send OTP button */}
                        <Form.Group
                          className="form-group"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Form.Label style={{ minWidth: "100px" }}>
                            {t("recovery_email_placeholder")}:
                          </Form.Label>
                          <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={
                              recovery?.recoveryEmail?.email
                                ? recovery?.recoveryEmail?.email
                                : t("recovery_email_placeholder")
                            }
                            required
                          />
                          {emailOtpSent && !verifiedEmail && (
                            <Form.Control
                              type="text"
                              value={emailOtp}
                              onChange={(e) => setEmailOtp(e.target.value)}
                              placeholder={t("enter_otp_for_email")}
                              required
                            />
                          )}
                          {emailOtpSent && !verifiedEmail ? (
                            <Button
                              style={{ minWidth: "100px" }}
                              onClick={handleVerifyOtp}
                              disabled={!emailOtp}
                            >
                              {t("verify_otp_button")}
                            </Button>
                          ) : (
                            <Button
                              style={{ minWidth: "100px" }}
                              onClick={handleSendOtp}
                              disabled={!email || emailOtpSent}
                            >
                              {t("send_otp_button")}
                            </Button>
                          )}
                        </Form.Group>
                        {/* Error message */}
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        {/* Phone Field with Send OTP button */}
                        <Form.Group
                          className="form-group mt-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Form.Label style={{ minWidth: "100px" }}>
                            {t("recovery_phone")}:
                          </Form.Label>
                          {/* <Form.Control
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder={t('enter_recovery_phone_number')}
                  required
                /> */}

                          <PhoneInput
                              country={(user?.country || "us").toLowerCase()}
                              value={phone || recovery?.recoveryMobile?.mobile}
                            onChange={handlePhoneChangeRecovery}
                            inputStyle={{ width: "100%" }}
                            // placeholder={recovery?.recoveryMobile?.mobile ? recovery?.recoveryMobile?.mobile  : ""}
                            required
                          />
                          {/* OTP field and buttons for Phone */}
                          {phoneOtpSent && !verified.phone && (
                            <>
                              <Form.Control
                                type="number"
                                value={phoneOtp}
                                maxLength={15}
                                onChange={(e) => setPhoneOtp(e.target.value)}
                                placeholder={t("enter_otp_for_phone")}
                                required
                              />
                              <Button
                                style={{ minWidth: "100px" }}
                                // onClick={() => handleVerifyOtp1('phone')}
                                onClick={handleVerifyOTPMobile}
                                disabled={!phoneOtp}
                              >
                                {t("verify_otp_button")}
                              </Button>
                            </>
                          )}

                          {/* Send OTP button for Phone */}
                          {!phoneOtpSent && !verified.phone && (
                            <Button
                              style={{ minWidth: "100px" }}
                              // onClick={() => handleSendOtp1('phone')}
                              onClick={handleGenerateOTPMobile}
                              disabled={!phone || phoneOtpSent}
                            >
                              {t("send_otp_button")}
                            </Button>
                          )}
                        </Form.Group>
                      </Form>
                      <div
                        style={{
                          marginTop: "15px",
                          color: "#555",
                          fontSize: "12px",
                          width: "100%",
                          textAlign: "right",
                        }}
                      >
                        <strong style={{ color: "red" }}>{t("note")}:</strong> 
                        {t("recoveryContactReplacementNotice")}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </div>
          </div>
          {/* Invitation*/}
          {/* <div className="accordion" style={{ marginBlock: '5px' }}>
      <div className="accordion-item" style={{ borderBottom: '1px solid #a5a5a5' }}>
        <div
          className="accordion-title"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingInline: '20px',
          }}
          onClick={() => setIsActiveInvitation(!isActiveInvitation)}
        >
          <div style={{ display: 'flex', fontSize: '20px', paddingBlock: '5px' }}>
            {t('invite_a_friend')}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveRecovery ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
        </div> */}
          {isActiveInvitation && (
            <div id="invitation" className="accordion-content">
              <Card>
                <Card.Body>
                  <Form>
                    <Form.Group
                      className="form-group"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Form.Label
                        style={{
                          disaplay: "flex",
                          fontSize: "16px",
                          marginBlock: "auto",
                        }}
                      >
                        {t("email_label")}:
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder={t("email_placeholder")}
                        value={invitationEmail}
                        onChange={(e) => setInvitationEmail(e.target.value)}
                        required
                      />

                      <Button
                        style={{ minWidth: "100px", whiteSpace: "nowrap" }}
                        disabled={!invitationEmail}
                        onClick={sendInvitation}
                      >
                        {t("send_invitation")}
                      </Button>
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Card>
            </div>
          )}
          {/* </div>
          </div> */}
          {/* Data Erase */}
          <div
            id="dataEraseRequest"
            className="accordion"
            style={{ marginBlock: "5px" }}
          >
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                // onClick={() => toggleSection('dataEraseRequest')}
                onClick={() => {
                  toggleSection("dataEraseRequest");
                  setIsActiveErase(!isActiveErase);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                  {t("request_data_erasure")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveErase ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveErase && (
                <>
                  <div
                    className="accordion-content"
                    style={{ padding: "15px 20px", backgroundColor: "#fff" }}
                  >
                    <Card
                      style={{
                        border: "none",
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body style={{ padding: "20px" }}>
                        <h5 style={{ fontWeight: "600", color: "#d9534f" }}>
                          {t("request_data_erasure_or_account_deletion")}
                        </h5>
                        <p style={{ color: "#555", marginBottom: "20px" }}>
                          {t("request_data_erasure_description")}
                        </p>
                        <div className="d-flex flex-column flex-md-row gap-2">
                          <Button
                            variant="outline-danger"
                            style={{
                              padding: "10px 15px",
                              fontWeight: "500",
                              borderColor: "#d9534f",
                              color: "#d9534f",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              justifyContent:"center"
                            }}
                            onClick={() => handleShowPopup("erase-data")}
                          >
                            <MdOutlineDeleteSweep size={20} />
                            {t("request_data_erasure_option")}
                          </Button>
                          <Button
                            variant="danger"
                            style={{
                              padding: "10px 15px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              justifyContent:"center"
                            }}
                            onClick={() => handleShowPopup("delete-account")}
                          >
                            <MdPersonOff size={20} />
                            {t("request_account_deletion_option")}
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                  <Modal
                    show={showPopup}
                    onHide={() => setShowPopup(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t("confirm_action")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {t("irreversibleActionConfirmation")}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowPopup(false)}
                      >
                        {t("cancel")}
                      </Button>
                      <Button variant="danger" onClick={handleApiRequest}>
                        {t("confirm")}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              )}
            </div>
          </div>
          {/* Active Devices */}
          <div
            id="qrrequest"
            className="accordion"
            style={{ marginBlock: "5px" }}
          >
            <div
              className="accordion-item"
              style={{ borderBottom: "1px solid #a5a5a5" }}
            >
              <div
                className="accordion-title"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingInline: "20px",
                }}
                onClick={() => {
                  toggleSection("qrrequest");
                  setIsActiveRequest(!isActiveRequest);
                }}
                // onClick={() => setIsActiveRequest(!isActiveRequest)}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    paddingBlock: "5px",
                  }}
                >
                  {t("active_devices")}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isActiveRequest ? (
                    <MdKeyboardArrowUp size={30} />
                  ) : (
                    <MdKeyboardArrowDown size={30} />
                  )}
                </div>
              </div>
              {isActiveRequest && (
                <div className="accordion-content">
                  <Card>
                    <Card.Body>
                      <h5>{t("active_devices")}</h5>
                      {loading ? (
                        <Spinner animation="border" />
                      ) : activeDevices?.length === 0 ? (
                        <p>{t("no_other_active_devices")}</p>
                      ) : (
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th>{t("device_info")}</th>
                              <th>{t("Ip")}</th>
                              <th>{t("login_time")}</th>
                              <th>{t("actions")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeDevices?.map((device) => (
                              <tr key={device?._id}>
                                <td>{device?.deviceInfo}</td>
                                <td>{device?.ip}</td>
                                <td>
                                  {new Date(device?.loginTime).toLocaleString()}
                                </td>
                                <td>
                                  {/* <FaTrash
                      style={{ cursor: 'pointer', color: 'red' }}
                      onClick={() => handleDelete(device?._id)}
                    /> */}
                                  <span
                                    style={{ cursor: "pointer", color: "red" }}
                                    onClick={() => handleDelete(device?._id)}
                                  >
                                    {t("logout")}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              )}
            </div>
          </div>
         </Col>
        {/* //  </Row> */}
         </Container>
      )}
      <Toaster position="top-right" reverseOrder={false} />
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("crop_image")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "400px", position: "relative" }}>
          {imageSrc && (
            //<div className="crop-container">
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
              //<div className="crop-overlay" />
            //</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
          <div>
                <label className="me-2">{t("zoom")}:</label>
                <input
                  type="range"
                  min="1"
                  max="3"
                  step="0.1"
                  value={zoom}
                  onChange={(e) => setZoom(e.target.value)}
                  className="form-range"
                  style={{ width: "150px" }}
                />
              </div>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("cancel")}
          </Button>
          <Button variant="primary" onClick={showCroppedImage}>
            {t("crop_image")}
          </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserAccountSetting;
